import React from "react";
import { GeneralIcon } from "modules/common/components/planr/icon/Generalcon";
import { PlanrButton } from "modules/common/components/planr/button/Button";
import styles from "./UnitEconomicsPage.module.scss";

/** Компактная плашка «пусто»: почему пусто и как вернуть строки */
export const EmptyState = ({ text, onReset }: EmptyStateProps) => (
    <div className={styles.empty}>
        <GeneralIcon type="general-search" size={16} className={styles.emptyIcon} />
        <span className={styles.emptyText}>{text}</span>
        {onReset && (
            <PlanrButton type="lightblueish" size="small" className={styles.emptyAction} onClick={onReset}>
                Показать всех
            </PlanrButton>
        )}
    </div>
);

interface EmptyStateProps {
    text: string;
    onReset?: () => void;
}
